import React from 'react';
import { ICONIFY } from '../../../../../Constants/iconify';
import CommonNode from '../../shared/CommonNode';
import NodeWrapper from '../../shared/NodeWrapper';

function RatingNode({ data }) {
    return (
        <NodeWrapper nodeId={data?.id}>
            <CommonNode data={data} icon={ICONIFY.RATING} />
        </NodeWrapper>
    );
}

export default React.memo(RatingNode)
